export default __webpack_public_path__ + "static/media/apparel_cat_tile.8a3e8914.jpg";